var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePlaceHolder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#paint0_linear_1505_30398)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5467 21.4924C13.8024 21.4924 9.75 22.2404 9.75 25.2324C9.75 28.2255 13.7771 28.9999 18.5467 28.9999C23.291 28.9999 27.3434 28.253 27.3434 25.2599C27.3434 22.2668 23.3174 21.4924 18.5467 21.4924",
    fill: "url(#paint1_linear_1505_30398)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5467 18.6424C21.7785 18.6424 24.3679 16.0519 24.3679 12.8212C24.3679 9.5905 21.7785 7 18.5467 7C15.316 7 12.7255 9.5905 12.7255 12.8212C12.7255 16.0519 15.316 18.6424 18.5467 18.6424",
    fill: "url(#paint2_linear_1505_30398)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1505_30398",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1505_30398",
    x1: 9.75,
    y1: 21.4924,
    x2: 9.75,
    y2: 28.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1505_30398",
    x1: 12.7255,
    y1: 7,
    x2: 12.7255,
    y2: 18.6424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceHolder2);
export default __webpack_public_path__ + "static/media/profile_place_holder (2).a2e6cda0.svg";
export { ForwardRef as ReactComponent };